import { useState } from "react";

export const useArrayState = <T,>(initialValue?: T[] | (() => T[])) => {
    const [values, setValues] = useState<T[]>(initialValue || []);

    const pushValue = (value: any) => {
        setValues(prevValues => [...prevValues, value]);
    };

    const updateValue = (index: number) => (value: any) => {
        setValues(prevValues => prevValues.map((v, i) => i === index ? value : v));
    };

    const deleteValue = (index: number) => () => {
        setValues(prevValues => prevValues.filter((_, i) => i !== index));
    };

    return {
        values,
        setValues,
        pushValue,
        updateValue,
        deleteValue,
    };
};
